module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepup"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Service Questions')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [(_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/service_question/questions"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Service Questions List')))])])], 1) : _vm._e(), _c('div', {
    staticClass: "col-sm-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/service_question/shop_results"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Service Questions Result List')))])])], 1), (_vm.isSystemManagement || _vm.isHumanStaff) ? _c('div', {
    staticClass: "col-sm-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/service_question/movie"
    }
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _c('p', [_vm._v("動画ファイル管理")])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53b01c56!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceQuestion.vue
// module id = 820
// module chunks = 1